module.exports = __webpack_public_path__ + "static/media/wuerchahushan_plant.a3a4953c.png";